import debug from 'debug';

debug.enable(process.env.DEBUG);

const inBrowser = () => (typeof window === "object");

const UNHANDLED = () => {
    console.error('Not handling exceptions here!');
    return (e) => console.error('Unhandled exception was hit!--------', e);
};

export { debug, UNHANDLED, inBrowser };



// WEBPACK FOOTER //
// ./src/utils/index.ts